import { useEffect, useRef } from "react";
import "./FloatingBubble.css";

export default function FloatingBubble({ anchorEl, iframeEl, label, onClose, children }) {
  const ref = useRef(null);

  useEffect(() => {
    if (!anchorEl || !ref.current) return;

    const reposition = () => {
      const el = ref.current;
      if (!el || !anchorEl.isConnected) { onClose(); return; }
      const aRect = anchorEl.getBoundingClientRect();
      const iRect = iframeEl?.getBoundingClientRect() ?? { top: 0, left: 0, bottom: 0 };
      if (iframeEl && (aRect.bottom < 0 || aRect.top > (iframeEl.clientHeight ?? 9999))) {
        onClose();
        return;
      }
      const top = iRect.top + aRect.bottom + 8 + window.scrollY;
      const left = Math.max(8, iRect.left + aRect.left + window.scrollX);
      el.style.top = `${top}px`;
      el.style.left = `${left}px`;
    };

    reposition();
    const onScroll = () => reposition();
    const onResize = () => reposition();
    window.addEventListener("scroll", onScroll, true);
    window.addEventListener("resize", onResize);
    const iw = iframeEl?.contentWindow;
    iw?.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll, true);
      window.removeEventListener("resize", onResize);
      iw?.removeEventListener("scroll", onScroll);
    };
  }, [anchorEl, iframeEl, onClose]);

  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    const onOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) onClose();
    };
    document.addEventListener("keydown", onKey);
    document.addEventListener("mousedown", onOutside);
    return () => {
      document.removeEventListener("keydown", onKey);
      document.removeEventListener("mousedown", onOutside);
    };
  }, [onClose]);

  return (
    <div ref={ref} className="editor-bubble">
      {label && <div className="editor-bubble-label">Editing: {label}</div>}
      <div className="editor-bubble-body">{children}</div>
    </div>
  );
}
